import { get, post } from "./request";

export const ACTIVITY_TYPE_NEW_USER_GIFT = "new_user_gift";
export const ACTIVITY_TYPE_NEW_USER_DOWNLOAD_GIFT = "download_card";

export const activityApi = {
  getStatus: (activityType, token) =>
    get("/activity/status", {
      type: activityType,
      token,
    }),
  claim: (activityType, token) =>
    post(
      "/activity/claim",
      { activity_type: activityType },
      {
        params: { token },
      },
    ),
};
